import React, { useEffect, useState, useRef } from 'react';
import { Link } from 'react-router-dom';
import { useScrollEffects } from '../hooks/useScrollEffects';

const Hero = () => {
  const [isVisible, setIsVisible] = useState(false);
  const { scrollY } = useScrollEffects();
  const heroRef = useRef();

  useEffect(() => {
    setIsVisible(true);
  }, []);

  // Parallax effect for hero content
  const parallaxOffset = scrollY * 0.5;
  const particlesOffset = scrollY * 0.3;

  return (
    <section className="hero" ref={heroRef}>
      <div className="hero-content">
        <div className={`hero-text ${isVisible ? 'animate-fade-in' : ''}`}>
          <h1>Connect. Collaborate. Convert.</h1>
          <h2>Helping Restaurants Reach Their Target Audiences</h2>
          <p>We are committed to revolutionizing the way modern restaurants attract new customers in this digital era. We work closely with our restaurant partners to understand their unique goals and tailor our strategies to help them achieve success.</p>
          <div className="hero-buttons">
            <Link to="/contact" className="btn">DROP YOUR MARKETING BRIEF</Link>
            <Link to="/about" className="btn btn-secondary">Learn More</Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
